var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08988 0.841954L12.4501 0L11.4991 3.33102L10.6305 2.43361C7.67238 4.94927 4.13196 6.80191 0.239186 7.76084L0 6.78987C3.71704 5.87423 7.10069 4.10989 9.93351 1.71353L9.08988 0.841954ZM10 5.5C10 4.94772 10.4477 4.5 11 4.5H13C13.5523 4.5 14 4.94772 14 5.5V13C14 13.5523 13.5523 14 13 14H11C10.4477 14 10 13.5523 10 13V5.5ZM6 7C5.44772 7 5 7.44772 5 8V13C5 13.5523 5.44772 14 6 14H8C8.55229 14 9 13.5523 9 13V8C9 7.44772 8.55229 7 8 7H6ZM1 9C0.447715 9 0 9.44771 0 10V13C0 13.5523 0.447715 14 1 14H3C3.55228 14 4 13.5523 4 13V10C4 9.44771 3.55228 9 3 9H1Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.5ce498d1.svg";
export { ForwardRef as ReactComponent };